import * as $ from 'jquery'
// JavaScript Document

// move gravity form fields into new divs				
$( ".gf-move-left" ).appendTo( ".gf-left-side" );
$( ".gf-move-right" ).appendTo( ".gf-right-side");
$( ".gform_footer" ).appendTo( ".gf-right-side");

// show the second dropdown and remove the selected option from the other dropdowns
$(".interest-block-1").change ( function () {
    var dropdownval = $(this).val();
	$(".gfield_select").not(this).find('option[value="' + dropdownval + '"]').remove();
    $(".interest-block-2").removeClass("hide");
	$(".gform_footer").addClass("extra-padding");
} )

// show the third dropdown and remove the selected option from the other dropdowns
$(".interest-block-2").change ( function () {
    var dropdownval = $(this).val();
	$(".gfield_select").not(this).find('option[value="' + dropdownval + '"]').remove();
    $(".interest-block-3").removeClass("hide");
} );

// remove the bullets from gravity forms
$(".removeBullet").find( "li" ).attr("style", "list-style: none!important;");
$(".gfield_checkbox").attr("style", "margin-left: 0!important;");

$(".gf_right_space").attr("style", "padding-right: 20px!important;");

// character count on the details of inquiry field.
var maxLength = 1000;
$( "#field_9_11" ).append( "<li class=\"remainingCharacters\">" + maxLength + " characters remaining<li>" );

$('#input_9_11').keyup(function() {
	var textlen = maxLength - $(this).val().length;
	
	if ($(this).val().length >= maxLength) {
		$(this).val($(this).val().substr(0, maxLength));
		
		$('.remainingCharacters').text('0 characters remaining');
    }
	else {
		$('.remainingCharacters').text(textlen + ' characters remaining');
	}
});
